import { cloneDeep } from 'lodash-es'
import { CheckoutData } from '~/composables/useCheckoutState/interfaces/CheckoutData'
import { CHECKOUT_INITIAL_DATA } from '~/composables/useCheckoutState/variables'

export function getInitialCheckoutState (): CheckoutData {
  return cloneDeep(CHECKOUT_INITIAL_DATA)
}
